import Splide from '@splidejs/splide';

if (document.querySelector('#js-Microevents')) {
  new Splide( '#js-Microevents', {
    pagination: true,
    arrows: true,
    gap: 30,
    autoplay: true,
  } ).mount();
}
